export const // Blogs Api
  GET_ALL_PUBLISHED_BLOGS = "blog/all/published",
  GET_BLOG_BY_ID = "blog/by-id",
  GET_BLOGS_BY_FILTERS = "blog/by-or-filters",
  // { id } -> { siblings: [{ id, title, language }] }: a guide's published translations
  GET_BLOG_SIBLINGS = "blog/siblings",
  // { id } -> { category, related: [{ kind, id, title, language }], cities: [key] }
  GET_BLOG_RELATED = "blog/related",
  // { category, language } -> { category, languages, guides, faq, cities }
  GET_BLOG_CATEGORY = "blog/category",
  // { language } -> { categories: [{ key, count }] }
  GET_BLOG_CATEGORIES = "blog/categories",
  //Questions Api
  GET_ALL_PUBLISHED_QUESTIONS = "question/all/published",
  GET_QUESTIONS_BY_FILTERS = "question/by-filter",
  GET_QUESTION_BY_ID = "question/by-id",
  // { id } -> { category, guide, faq, cities } for an editorial FAQ
  GET_QUESTION_RELATED = "question/related",
  ASK_QUESTION = "question/post",
  EDIT_QUESTION = "question/edit",
  ANSWER_QUESTION = "question/answer",
  DELETE_QUESTION = "question/delete",
  GET_ALL_MINE_QUESTIONS = "question/mine",
  EDITE_ANSWER = "question/editeanswer",
  DELETE_ANSWER = "question/deleteanswer",
  GET_QUESTIONS_ANSWERED_BY_ME = "question/get-questions-answered-by-me",
  //Lawyers Api
  GET_LAWYER = "lawyer/all",
  GET_LAWYER_BY_ID = "lawyer/by-id",
  GET_LAWYER_BY_FILTERS = "lawyer/by-or-filters",
  // { governorate, barLevel, name, page, pageSize, excludeId } -> { data, total, page, pageSize }
  GET_LAWYER_DIRECTORY = "lawyer/directory",
  //Auth Api
  USER_REGISTER = "user/register",
  USER_LOGIN = "user/login",
  CURRENT_USER = "user/me",
  UPDATE_WORKING_HOURS = "lawyer/update-working-hours",
  BILLING_ME = "billing/me",
  BILLING_TRIAL = "billing/trial",
  BILLING_CHECKOUT = "billing/checkout",
  BILLING_CONFIRM = "billing/confirm",
  BILLING_CANCEL = "billing/cancel",
  BILLING_RESUME = "billing/resume",
  BILLING_SANDBOX_COMPLETE = "billing/sandbox/complete",
  LAWYER_RECORD_VIEW = "lawyer/view",
  LAWYER_RECORD_CALL = "lawyer/call",
  LAWYER_MY_STATS = "lawyer/my-stats",
  REFRESH = "user/refresh",
  FORGOT_PASSWORD = "user/forgot-password",
  BECOME_LAWYER = "user/register/lawyer",
  RESET_PASSWORD = "user/reset-password",
  //User api
  UPDATE_PROFILE = "user/update",
  UPDATE_LAWYER_PROFILE = "lawyer/update",
  UPDATE_USERNAME = "lawyer/update-username",
  CHANGE_PASSWORD = "user/change-password",
  VERIFY_EMAIL = "user/verify/",
  CHANGE_EMAIL = "user/change-email",
  UPLOAD_IMAGE = "user/profile-picture",
  //Appointment Api
  SCHEDULE_APPOINTMENT = "calendar/appointment/schedule",
  CANCEL_APPOINTMENT = "calendar/appointment/cancel",
  ACCEPT_APPOINTMENT = "calendar/appointment/accept",
  GET_APPOINTEMENTS_BY_FILTERS = "calendar/by-or-filters",
  GET_MY_APPOINTMENTS = "calendar/appointment/mine",
  GET_LAWYER_TIME_BLOCKERS = "calendar/timeBlocker/lawyer",
  //Events Api
  GET_MY_EVENTS = "calendar/event/mine",
  CREATE_EVENT = "calendar/event/create",
  UPDATE_EVENT = "calendar/event/update",
  DELETE_EVENT = "calendar/event/delete",
  //Contact Api
  CONTACT_FORM = "email/contact-us";
